/**
 * TanStack Query hooks for `three-tier-pricing-starter-agency-enterprise`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	threeTierPricingStarterAgencyEnterpriseQueryKeys,
	type CreateThreeTierPricingStarterAgencyEnterpriseBody,
	type ListThreeTierPricingStarterAgencyEnterpriseResponse,
	type ThreeTierPricingStarterAgencyEnterpriseRow,
} from "./api";

export function useThreeTierPricingStarterAgencyEnterpriseList(): UseQueryResult<ListThreeTierPricingStarterAgencyEnterpriseResponse, Error> {
	return useQuery({
		queryKey: threeTierPricingStarterAgencyEnterpriseQueryKeys.list(),
		queryFn: list,
	});
}

export function useThreeTierPricingStarterAgencyEnterpriseCreate(): UseMutationResult<ThreeTierPricingStarterAgencyEnterpriseRow, Error, CreateThreeTierPricingStarterAgencyEnterpriseBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: threeTierPricingStarterAgencyEnterpriseQueryKeys.all });
		},
	});
}

export function useThreeTierPricingStarterAgencyEnterpriseDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: threeTierPricingStarterAgencyEnterpriseQueryKeys.all });
		},
	});
}
